// QuizQuestion.js
import React, { useState } from "react";
import "./QuizQuestion.css";

const QuizQuestion = ({ quizData, onAnswer, isLoading }) => {
  const { question, choices, correctAnswer } = quizData;
  const [selected, setSelected] = useState(null);
  const [isAnswered, setIsAnswered] = useState(false);

  const handleSelect = (choiceLabel) => {
    if (!isAnswered && !isLoading) {
      setSelected(choiceLabel);
      setIsAnswered(true);
      // Delay for animations to complete before verifying
      setTimeout(() => {
        onAnswer(choiceLabel);
      }, 600);
    }
  };

  const getButtonClass = (choiceLabel) => {
    if (!isAnswered) return "";
    if (choiceLabel === correctAnswer) {
      return "correct sparkle-effect";
    } else if (choiceLabel === selected) {
      return "incorrect slashing-effect";
    }
    return "";
  };

  return (
    <div className={`quiz-container ${isLoading ? 'loading' : ''}`}>
      <h2>{question}</h2>
      <div className="quiz-buttons">
        {choices.map((choice) => (
          <button
            key={choice.label}
            onClick={() => handleSelect(choice.label)}
            className={getButtonClass(choice.label)}
            disabled={isAnswered || isLoading}
          >
            {choice.label}: {choice.text}
          </button>
        ))}
      </div>
    </div>
  );
};

export default QuizQuestion;